import axios from "../plugins/axios";

export default {
  sync() {
    return axios.post("/signal/sync")
      .then((response) => response.data);
  },
  paginateAll() {
    return axios.get("/web_api/v1/signal/?include=customer")
      .then((response) => response.data);
  },
  paginateByCustomer(customerId, page = 1, perPage = 10, includes = []) {
    return axios.get(`/web_api/v1/signal/paginate_by_customer/${customerId}`, {
      params: {
        page,
        perPage,
        include: includes,
      },
    })
      .then((response) => response.data);
  },
  paginateByCustomerFamily(customerId, page = 1, perPage = 10, includes = []) {
    return axios.get(`/web_api/v1/signal/paginate_by_customer_family/${customerId}`, {
      params: {
        page,
        perPage,
        include: includes,
      },
    })
      .then((response) => response.data);
  },
  snooze(signalId, snoozedUntil) {
    return axios.put(`/web_api/v1/signal/snooze/${signalId}`, { snoozed_until: snoozedUntil })
      .then((response) => response.data);
  },
  finish(signal) {
    return axios.put(`/web_api/v1/signal/finish/${signal.id}`, {
      status: signal.status,
      comment: signal.comment,
      finished_by: signal.finishedBy,
    })
      .then((response) => response.data);
  },
  deleteSignal(signalId) {
    return axios.delete(`/web_api/v1/signal/${signalId}`)
      .then((response) => response.data);
  },
};
